export default __webpack_public_path__ + "static/media/circleChat.f6246c1c.svg";